import _ from 'lodash';
import * as types from '../constants/action-types';

const initialState = {
  data: [],
  referralData: {},
  isFetching: false,
  error: ''
};

export default function entitlements (state = initialState, action) {
  const { entitlementsArray, referralData = {}, isFetching, error } = action;

  switch (action.type) {
  case types.ENTITLEMENTS_FETCH_REQUEST:
  case types.FETCH_GUEST_REFERRAL_ENTITLEMENTS_REQUEST:
    return _.merge({}, state, {
      isFetching
    });

  case types.ENTITLEMENTS_FETCH_SUCCESS:
    return _.merge({}, state, {
      data: entitlementsArray,
      referralData,
      isFetching
    });

  case types.FETCH_GUEST_REFERRAL_ENTITLEMENTS_SUCCESS:
    return _.merge({}, state, {
      guestReferralData: entitlementsArray,
      isFetching
    });

  case types.ENTITLEMENTS_FETCH_FAILURE:
    return _.merge({}, state, {
      error
    });

  case types.FETCH_GUEST_REFERRAL_ENTITLEMENTS_FAILURE:
    return _.merge({}, state, {
      guestReferralError: error
    });

  default:
    return state;
  }
}
